import { apiRequest } from "../../services/apiService";
import {
  GET_LOGIN_USER_FAIL, GET_LOGIN_USER_SUCCESS, GET_LOGIN_USER_REQUEST
} from "../constant";

export const userDetailHeader = () => {
  return async (dispatch) => {
    dispatch({ type: GET_LOGIN_USER_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/users/getUserPer`,
    });
    if (response) {
      dispatch({ type: GET_LOGIN_USER_SUCCESS, payload: response.data });
    } else if (error) {
      dispatch({ type: GET_LOGIN_USER_FAIL });
    }
  };
};
